const initialState = {
  loading: false,
  onboarding_completed: false,
  onboarding_step: 0,
  onboarding_completed_at: null,
  dismissed: false,
};

export const buyerOnboardingWizard = (state = initialState, action) => {
  switch (action.type) {
    case "BUYER_ONBOARDING_WIZARD_LOADING":
      return { ...state, loading: true };
    case "BUYER_ONBOARDING_WIZARD_LOADED":
      return {
        ...state,
        loading: false,
        onboarding_completed: action.payload.onboarding_completed,
        onboarding_step: action.payload.onboarding_step || 0,
        onboarding_completed_at: action.payload.onboarding_completed_at,
      };
    case "BUYER_ONBOARDING_WIZARD_ERROR":
      return { ...state, loading: false };
    case "BUYER_ONBOARDING_WIZARD_STEP":
      return { ...state, onboarding_step: action.payload };
    case "BUYER_ONBOARDING_WIZARD_COMPLETED":
      return { ...state, onboarding_completed: true, onboarding_step: 5 };
    case "BUYER_ONBOARDING_WIZARD_COMPLETED_OK":
      return {
        ...state,
        onboarding_completed: true,
        onboarding_step: 5,
        onboarding_completed_at: action.payload.onboarding_completed_at,
      };
    case "BUYER_ONBOARDING_WIZARD_DISMISS":
      return { ...state, dismissed: true };
    default:
      return state;
  }
};
